"use strict";

var Cookie = require('cookies-js');

function setItem(key, val, options) {
  if (val == null) {
    Cookie.expire(key);
  } else {
    Cookie.set(key, val, options);
  }
}

function getItem(key) {
  return Cookie.get(key);
}

function removeItem(key) {
  Cookie.expire(key);
}

module.exports = {
  setItem: setItem,
  getItem: getItem,
  removeItem: removeItem
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/optin/~/@flowio/storage/lib/cookie-storage.js
// module id = 588
// module chunks = 0 1